import { render, staticRenderFns } from "./ResendConfirm.vue?vue&type=template&id=14f95f8a"
import script from "./ResendConfirm.vue?vue&type=script&lang=js"
export * from "./ResendConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports